import { Core } from 'chessboard/core/config/types';

/**
 * The various events that only change the selected node.
 */
export const selectedNodeChangeEvents: string[] = [
  Core.APIEvents.MoveBackward,
  Core.APIEvents.MoveForward,
  Core.APIEvents.SelectLineEnd,
  Core.APIEvents.SelectLineStart,
  Core.APIEvents.SelectNode,
];
